import { render, staticRenderFns } from "./FinalisasiBAPenolakan.vue?vue&type=template&id=a67dda2c&"
import script from "./FinalisasiBAPenolakan.vue?vue&type=script&lang=js&"
export * from "./FinalisasiBAPenolakan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports